import { Download, Smartphone, X } from 'lucide-react';

interface DownloadGuestAppModalProps {
  onClose: () => void;
}

export function DownloadGuestAppModal({ onClose }: DownloadGuestAppModalProps) {
  const handleDownloadIOS = () => {
    // TODO: Replace with actual App Store link when available
    window.open('https://apps.apple.com/app/wlkthru-guest', '_blank');
  };

  const handleDownloadAndroid = () => {
    // TODO: Replace with actual Google Play link when available
    window.open('https://play.google.com/store/apps/details?id=co.wlkthru.guest', '_blank');
  };

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-[200] p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden">
        {/* Header */}
        <div className="relative p-6 border-b border-gray-200 bg-gradient-to-br from-blue-50 to-purple-50">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 p-2 rounded-full hover:bg-white/50 transition-colors"
            aria-label="Close"
          >
            <X className="w-5 h-5 text-gray-600" />
          </button>

          <div className="flex items-center gap-3 mb-2">
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center shadow-lg">
              <Smartphone className="w-7 h-7 text-white" />
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-900">Download Walkthru</h2>
              <p className="text-sm text-gray-600">Guest App Required</p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          <div className="text-center space-y-2">
            <p className="text-base text-gray-700 font-medium">
              AR measurements require the Wlkthru Guest App
            </p>
            <p className="text-sm text-gray-600">
              Get more accurate measurements with advanced AR technology
            </p>
          </div>

          {/* Features */}
          <div className="bg-gray-50 rounded-xl p-4 space-y-2">
            <div className="flex items-start gap-3">
              <div className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                <div className="w-2 h-2 rounded-full bg-green-600"></div>
              </div>
              <p className="text-sm text-gray-700">Precise AR-powered measurements</p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                <div className="w-2 h-2 rounded-full bg-green-600"></div>
              </div>
              <p className="text-sm text-gray-700">Real-time collaboration with host</p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                <div className="w-2 h-2 rounded-full bg-green-600"></div>
              </div>
              <p className="text-sm text-gray-700">Instant measurement sharing</p>
            </div>
          </div>

          {/* Download Buttons */}
          <div className="space-y-3">
            <button
              onClick={handleDownloadIOS}
              className="w-full p-4 bg-black hover:bg-gray-800 text-white rounded-xl transition-colors flex items-center justify-center gap-3 group"
            >
              <Download className="w-5 h-5 group-hover:animate-bounce" />
              <div className="text-left">
                <div className="text-xs opacity-80">Download on the</div>
                <div className="text-base font-semibold">App Store</div>
              </div>
            </button>

            <button
              onClick={handleDownloadAndroid}
              className="w-full p-4 bg-green-600 hover:bg-green-700 text-white rounded-xl transition-colors flex items-center justify-center gap-3 group"
            >
              <Download className="w-5 h-5 group-hover:animate-bounce" />
              <div className="text-left">
                <div className="text-xs opacity-90">Get it on</div>
                <div className="text-base font-semibold">Google Play</div>
              </div>
            </button>
          </div>

          <div className="text-center pt-2">
            <button
              onClick={onClose}
              className="text-sm text-gray-500 hover:text-gray-700 font-medium transition-colors"
            >
              Maybe later
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
